import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ModalEquipmentCoatingEditComponent} from './modal-equipment-coating-edit.component';
import {FieldModule} from "../../inputs/field/field.module";
import {ButtonModule} from "../../buttons/button/button.module";
import {ReactiveFormsModule} from "@angular/forms";


@NgModule({
  declarations: [
    ModalEquipmentCoatingEditComponent
  ],
  exports: [
    ModalEquipmentCoatingEditComponent
  ],
  imports: [
    FieldModule,
    CommonModule,
    ButtonModule,
    ReactiveFormsModule
  ]
})
export class ModalEquipmentCoatingEditModule {
}
